import formatPrice from "@/lib/formatPrice";
import styles from "@/styles/Price.module.scss";

export default function TrialFormatPriceSVOD({ price, ext, course }) {
  return (
    <span className={`${styles.price} ${styles.svod} ${styles.trial}`}>
      <span className={styles.slate}>
        <span className={styles.bold}>
          【初回購入限定】{course.trialTermText}
        </span>
      </span>
      <br className={styles.break} />
      {course.trialText}期間後は月額
      <span className={styles.bold}>{formatPrice(price)}</span>
      円（税込）
      {ext}
    </span>
  );
}
